import React from "react";
import Header from "../Components/Header/Header";
import Menu from "../Components/Menu/Menu";
import CartContainer from "../Components/Menu/CartContainer.jsx";
import { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import { CartPage } from "../Pages/cart.jsx";
///import {useNavigate} from "react-router-dom";
import { useLocation } from "react-router-dom";
import { NotFound } from "./404.jsx";

const MenuPage = () => {
  const [isDesktop, setIsDesktop] = useState(1);

  const location = useLocation();

  useEffect(() => {
    const mediaQuery = window.matchMedia("(min-width: 1024px)");

    if (mediaQuery.matches) {
      setIsDesktop(1);
    } else {
      setIsDesktop(0);
    }
    const handleMediaChange = (e) => {
      setIsDesktop(e.matches);
    };

    mediaQuery.addEventListener("change", handleMediaChange);

    return () => {
      mediaQuery.removeEventListener("change", handleMediaChange);
    };
  }, []);

  if (!["", "menu", "cart"].includes(location.pathname.split("/").pop())) {
    return <NotFound />;
  }

  return (
    <div className="h-full w-full relative lg:pr-[150px]">
      <CartContainer versionDesktop={isDesktop} />

      <div className={`flex flex-col `}>
        <Header />
        <Routes>
          <Route path="/" element={<Menu />} />
          <Route path="/cart" element={!isDesktop ? <CartPage /> : <Menu />} />
        </Routes>
      </div>
    </div>
  );
};

export default MenuPage;
